
export const GET_CARTPRODUCTS_LOADING = 'GET_CARTPRODUCTS_LOADING';
export const GET_CARTPRODUCTS_SUCCESS = 'GET_CARTPRODUCTS_SUCCESS';
export const GET_CARTPRODUCTS_ERROR = 'GET_CARTPRODUCTS_ERROR';

export const ADD_TO_CART_LOADING = 'ADD_TO_CART_LOADING';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';

export const REMOVE_FROM_CART_LOADING = 'REMOVE_FROM_CART_LOADING';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_ERROR = 'REMOVE_FROM_CART_ERROR';

export const ORDER_PLACED_LOADING = 'ORDER_PLACED_LOADING';
export const ORDER_PLACED_SUCCESS = 'ORDER_PLACED_SUCCESS';
export const ORDER_PLACED_ERROR = 'ORDER_PLACED_ERROR';

export const RESET_CART_MESSAGE = 'RESET_CART_MESSAGE';